class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
    const baseThreshold = parseFloat(this.getAttribute('threshold')) || 200;
    this.threshold = Math.round(baseThreshold * (window.Shopify?.currency?.rate || 1));
    this.currencySymbol = window.currencySymbol || "$";
  }

  connectedCallback() {
    this.messageEl = this.querySelector('.free-shipping-text');
    this.progressEl = this.querySelector('.free-shipping-progress');
    if (!this.messageEl || !this.progressEl) return;
    this.updateFromCart();
  }

  updateFromCart() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        const cartTotal = cart.total_price / 100;
        this.updateProgress(cartTotal);
      });
  }

  updateProgress(cartTotal) {
    const amountLeft = this.threshold - cartTotal;
    const percent = Math.min((cartTotal / this.threshold) * 100, 100);

    this.messageEl.innerHTML =
      amountLeft > 0
        ? `${window.ShippingProgress.free_shipping_remaining.replace('{{ amount }}', this.currencySymbol + amountLeft.toFixed(2))}`
        : `${window.ShippingProgress.free_shipping_qualified}`;
    this.progressEl.style.width = percent + '%';
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}



document.addEventListener('click', (e) => {
  const isQtyButton = e.target.closest('.quantity__button');
  const isRemoveBtn = e.target.closest('[href*="/cart/change"]') || e.target.closest('button[name="updates[]"][value="0"]');

  if (isQtyButton || isRemoveBtn) {
    setTimeout(() => {
      document.querySelectorAll('free-shipping-bar').forEach((bar) => {
        bar.updateFromCart?.();
      });
    }, 2000);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('free-shipping-bar').forEach((bar) => {
    bar.updateFromCart?.();
  });
});